import React from 'react'
import Note from '../Note'
import Checklist from '../Checklist'
import DocumentList from '../DocumentList'
import DocumentFolder from '../DocumentFolder'
import DocumentFolderCreator from '../DocumentFolderCreator'
import SubCardGroup from '../SubCardGroup'

const ElementContainer = React.forwardRef(({
  id,
  elementName,

  ...props
}, ref) => {
  switch (elementName) {
    case '/Data/Note':
      return <Note ref={ref} {...props} id={id} />
    case '/Data/Checklist':
      return <Checklist ref={ref} {...props} id={id} />
    case '/Data/DocumentsList':
      return <DocumentList ref={ref} {...props} id={id} />
    case '/Data/DocumentsFolder':
      return <DocumentFolder ref={ref} {...props} id={id} />
    case '/Data/DocumentsFolderCreator':
      return <DocumentFolderCreator ref={ref} {...props} id={id} />
    case '/Data/SubCardGroup':
      return <SubCardGroup ref={ref} {...props} id={id} />
    default:
      return <div ref={ref}>UNKNOWN ELEMENT: {elementName}</div>
  }
})

export default ElementContainer
